<div class="loading-container">
    <div class="loading">
        <mat-spinner class="spinner" diameter=60></mat-spinner>
        <p class="loading-message">Finishing integration...
        </p>
    </div>
</div>
